import { propertyQueryKeys as e } from "../usePropertiesQueryKeys.mjs";
import { runPropertyMediaUpload as t } from "../media/runPropertyMediaUpload.mjs";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
import { propertiesApi as i } from "@maat/api-main";
//#region src/properties/gallery/useUpdateUnitGalleryMutation.ts
var a = () => {
	let a = r();
	return n({
		mutationFn: ({ propertyId: e, unitId: n, deletes: r = [], keep: a = [], additions: o = [], onUploadProgress: s }) => t({
			propertyId: e,
			groups: o,
			carriesEdits: !0,
			presign: (t) => i.presignPropertyImageEdits(e, {
				unit_id: n,
				updates: {
					deletes: r,
					keep: a
				},
				media: t.length > 0 ? t : void 0
			}),
			onUploadProgress: s
		}),
		onSuccess: (t, { propertyId: n, unitId: r }) => {
			a.invalidateQueries({ queryKey: e.gallery(n) }), a.invalidateQueries({ queryKey: e.images(n) }), a.invalidateQueries({ queryKey: e.property(n) }), a.invalidateQueries({ queryKey: e.unit(r) }), a.invalidateQueries({ queryKey: e.hostFeed() });
		}
	});
};
//#endregion
export { a as useUpdateUnitGalleryMutation };
